import { Button, Col, Row } from "reactstrap";
import { styles } from "../annonceDetaille";
import {
  FaCheckSquare,
  FaLocationArrow,
  FaMapMarkedAlt,
  FaMapMarker,
  FaMapMarkerAlt,
  FaPlus,
  FaPlusCircle,
  FaSearchLocation,
  FaSquare,
  FaTimesCircle,
} from "react-icons/fa";
import "../styles/AnnoncePublierForm.css";
import Exigence from "./Exigence";
import { useState } from "react";
import CheckboxAvanBen from "./CheckboxAvanBen";
import { toast } from "react-toastify";
import { API_URL } from "constants/ApiUrl";
import { useTranslation } from "react-i18next";

const AnnoncePublierForm = () => {
  const { t } = useTranslation();
  const initialAnnonce = {
    titre: "",
    description: "",
    endDate: "",
    position: "Gardien de but",
    category: ["u18-u19"],
    region: "",
    requirements: [],
    benefits: [],
    location: "",
  };

  const initialAvantages = [
    {
      key: "accommodation",
      label: t("postAd.avantages.accommodation"),
      checked: false,
    },
    {
      key: "transport",
      label: t("postAd.avantages.transport"),
      checked: false,
    },
    {
      key: "equipment",
      label: t("postAd.avantages.equipment"),
      checked: false,
    },
    { key: "salary", label: t("postAd.avantages.salary"), checked: false },
    { key: "contract", label: t("postAd.avantages.contract"), checked: false },
  ];

  const [titre, setTitre] = useState(initialAnnonce.titre);
  const [description, setDescription] = useState(initialAnnonce.description);
  const [endDate, setEndDate] = useState(initialAnnonce.endDate);
  const [position, setPosition] = useState(initialAnnonce.position);
  const [category, setCategory] = useState(initialAnnonce.category);
  const [region, setRegion] = useState(initialAnnonce.region);
  const [location, setLocation] = useState(initialAnnonce.location);
  const [exigences, setExigences] = useState(initialAnnonce.requirements);
  const [avantages, setAvantages] = useState(initialAvantages);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("authUser");

    const selectedBenefits = avantages
      .filter((b) => b.checked)
      .map((b) => b.key);

    const requirementsStr = exigences.join(", ");

    const payload = {
      title: titre,
      description,
      endDate,
      position,
      category,
      region,
      requirements: requirementsStr,
      benefits: selectedBenefits,
      location,
    };

    try {
      const response = await fetch(`${API_URL}/api/club/announcements`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(data.message || "Annonce publiée avec succès");
        setTitre("");
        setDescription("");
        setEndDate("");
        setPosition(initialAnnonce.position);
        setCategory(initialAnnonce.category);
        setRegion("");
        setLocation("");
        setExigences([]);
        setAvantages(avantages.map((b) => ({ ...b, checked: false })));
      } else {
        toast.error(data.message || "Erreur lors de la publication");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Erreur réseau, veuillez réessayer ultérieurement");
    }
  };

  return (
    <form className="annonce-form" onSubmit={handleSubmit}>
      <Row>
        <Col md={6} xs={12}>
          <div className="mb-5 px-3">
            <label className="form-label text-black">
              {t("postAd.labels.title")}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={t("postAd.labels.title")}
              value={titre}
              onChange={(e) => setTitre(e.target.value)}
              required
            />
          </div>
        </Col>

        <Col md={3} xs={12} sm={6} className="inputsmargin">
          <div className="mb-5 px-3">
            <label className="form-label">{t("postAd.labels.position")}</label>
            <select
              className="form-select"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
            >
              <option value="Goalkeeper">
                {t("postAd.options.positions.goalkeeper")}
              </option>
              <option value="Defender">
                {t("postAd.options.positions.defender")}
              </option>
              <option value="Midfielder">
                {t("postAd.options.positions.midfielder")}
              </option>
              <option value="Forward">
                {t("postAd.options.positions.forward")}
              </option>
            </select>
          </div>
        </Col>
        <Col md={3} xs={12} sm={6} className="inputsmargin">
          <div className="mb-5 px-3">
            <label className="form-label">{t("postAd.labels.level")}</label>
            <select className="form-select">
              <option value="Débutant">
                {t("postAd.options.levels.beginner")}
              </option>
              <option value="Intermédiaire">
                {t("postAd.options.levels.intermediate")}
              </option>
              <option value="Professionnel">
                {t("postAd.options.levels.professional")}
              </option>
            </select>
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div className="mb-5 px-3">
            <label className="form-label text-black">
              {t("postAd.labels.deadline")}
            </label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              required
            />
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div className="mb-5 px-3">
            <label className="form-label text-black">
              {t("postAd.labels.description")}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={t("postAd.labels.description")}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>
        </Col>
        <Col md={3} xs={12} sm={6} className="inputsmargin">
          <div className="mb-5 px-3 position-relative">
            <label className="form-label text-black">
              {t("postAd.labels.region")}
            </label>
            <div className="position-relative">
              <input
                type="text"
                className="form-control pr-4"
                placeholder={t("postAd.labels.region")}
                value={region}
                onChange={(e) => setRegion(e.target.value)}
                required
              />
              <FaMapMarkerAlt
                className="position-absolute top-50 end-0 translate-middle-y me-3 text-primary"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </Col>
        <Col md={3} xs={12} sm={6} className="inputsmargin">
          <div className="mb-5 px-3">
            <label className="form-label text-black">
              {t("postAd.labels.location")}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={t("postAd.labels.location")}
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              required
            />
          </div>
        </Col>
        <Col md={3} xs={12} sm={6} className="inputsmargin">
          <div className="mb-5 px-3">
            <label className="form-label">
              {t("postAd.labels.ageCategory")}
            </label>
            <select
              className="form-select"
              value={category[0]}
              onChange={(e) => setCategory([e.target.value])}
            >
              <option value="u14-u15">U14-U15 (14-15 ans)</option>
              <option value="u16-u17">U16-U17 (16-17 ans)</option>
              <option value="u18-u19">U18-U19 (18-19 ans)</option>
              <option value="u20-u21">U20-U21 (20-21 ans)</option>
              <option value="seniors">Seniors (18+ ans)</option>
            </select>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6} xs={12}>
          <Exigence exigences={exigences} setExigences={setExigences} />
        </Col>
        <Col md={6} xs={12}>
          <div className="mb-5 px-3">
            <h5 style={styles.sectionTitle} className="py-3 text-center">
              {t("postAd.sectionTitle")}
            </h5>
            <Row>
              <CheckboxAvanBen
                avantages={avantages}
                setAvantages={setAvantages}
              />
            </Row>
          </div>
        </Col>
        <Col md={12} className="text-end">
          <Button
            className="text-white"
            type="submit"
            style={{ backgroundColor: "#157088", borderRadius: "5px" }}
          >
            {t("postAd.labels.publish")}
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default AnnoncePublierForm;
